import { render, staticRenderFns } from "./clinicalCases.vue?vue&type=template&id=7add1816&scoped=true&"
import script from "./clinicalCases.vue?vue&type=script&lang=js&"
export * from "./clinicalCases.vue?vue&type=script&lang=js&"
import style0 from "./clinicalCases.vue?vue&type=style&index=0&id=7add1816&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7add1816",
  null
  
)

export default component.exports